import React from 'react'
import { Box, Center } from '@mantine/core'

/**
 * Renders a banner component.
 * @param {string} color The background color for the banner in hex format.
 * @param {JSX.Element} children The content for the banner.
 * @returns {JSX.Element}
 */
function Banner ({ color, children }) {
  return (
    <Box bg={color} h="35vh" w="100%">
      <Center h="100%">
        {children}
      </Center>
    </Box>
  )
}

export default React.memo(Banner)
